function AssetProject({projectData}) {

    const setAssetBodyExpanded = (id) =>{
        const container = document.getElementById(`asset_${id}`)
        const isExpanded = !container.classList.contains('collapsed');
        if(isExpanded){
            container.classList.add('collapsed')
        }
        else{
            container.classList.remove('collapsed')
        }
    }

    return(
        <div id={`asset_${projectData.id}`} className='assetContainer collapsed'>
            <div className='assetHeader' onClick={() => setAssetBodyExpanded(projectData.id)}>
                <img src={projectData.headerBG}/>
                <div className='assetHeaderShadow'/>
                <h2>{projectData.name}</h2>
            </div>
            
            <div className='assetBody'>
                {projectData.description || 'description'}
                
                <div className='assetLinksConiainer'>
                    <h2>More about this product on:</h2>
                    {projectData.links.map((link, i) => {
                        return(
                            <>
                                <a href={link.value}>{link.name}</a>
                                {projectData.links.length > i + 1 && (
                                    <span>|</span>
                                )}
                            </>
                        )
                    })}
                </div>
            </div>
            
            
        </div>
    )
}

export default AssetProject;